import { Button, IconMessage16, Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { useOfferContext } from '../OfferContext';
import { useChatContext } from '../../context';

export function ChatButtonContainer() {
  const {
    author: { isChatsEnabled },
    tracking: { onChatButtonClick },
  } = useOfferContext();
  const { openChat } = useChatContext();

  const handleClick = React.useCallback(() => {
    openChat();
    onChatButtonClick();
  }, [onChatButtonClick, openChat]);

  if (!isChatsEnabled) {
    return null;
  }

  return (
    <>
      <Responsive desktop tablet>
        <Button
          onClick={handleClick}
          beforeIcon={<IconMessage16 color="primary_100" />}
          theme="fill_secondary"
          data-name="ChatButton"
        />
      </Responsive>
      <Responsive phone>
        <Button onClick={handleClick} fullWidth size="M" theme="fill_secondary" data-name="ChatButton">
          Написать
        </Button>
      </Responsive>
    </>
  );
}
